import styled from 'styled-components';

import ConfirmOrCancelModal from '@ad-scripts/presentation/components/common/confirm_or_cancel_modal';

// this will be removed once the ConfirmAndCancelModal is refactored to be included in the common component library
const StyledConfirmOrCancelModal = styled(ConfirmOrCancelModal)`
  .Modal-backdrop {
    backdrop-filter: ${p => p.theme.overlay.backdropFilter};
    background-color: ${p => p.theme.overlay.color};
  }
  .Modal-backdrop,
  .Modal-wrapper {
    align-items: center;
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    overflow: hidden;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 2;
  }

  .modalCard-backdrop {
    align-items: center;
    backdrop-filter: ${p => p.theme.overlay.backdropFilter};
    background-color: ${p => p.theme.overlay.color};
    bottom: 0;
    display: flex;
    justify-content: center;
    left: 0;
    position: fixed;
    right: 0;
    top: 0;
    z-index: 10;
  }

  .modalCard-content {
    background-color: ${p => p.theme.colors.white};
    border-radius: 8px;
    box-shadow: ${p => p.theme.boxShadow.large};
    line-height: 162%;
    padding: 15px 20px 5px 20px;
  }
`;

export { StyledConfirmOrCancelModal };
